import React, { useContext, useEffect, useState } from 'react';
import { Accordion, Card } from 'react-bootstrap';
import { CurrentSingleContext } from '../../MyContexts/CurrentSingle_Context';
import SelectGalleryComp from '../../MySections/ImagesSetter/SelectGalleryComp';
import SelectImgComp from '../../MySections/ImagesSetter/SelectImgComp';
import EraseCheck from '../../MySections/PopUps/EraseCheck';

const SectionGallery = (props) => {

    const [currentSingle, setCurrentSingle] = useContext(CurrentSingleContext);

    const [gallerys, setGallerys] = useState(currentSingle.gallerys);
    const [curntGal, setCurntGal] = useState();

    const [imagesLst, setImagesLst] = useState(currentSingle.gallerys);
    const [thePopUp, setThePopUp] = useState("");


    useEffect(() => {
        setCurentGal();
    }, [])


    const setTheImagesLst = (galindx, urlsToSet) => {
        let tempo = currentSingle.gallerys;

        tempo[galindx].gallImages = urlsToSet;

        currentSingle.gallerys = [...tempo];
        setCurentGal();
    }

    const setTheMainImg = (galindx, urlToMainImg) => {
        let tempo = currentSingle.gallerys;

        tempo[galindx].mainImg = urlToMainImg;

        currentSingle.gallerys = [...tempo];
        setCurentGal();
    }



    const removeGall = (galindx) => {

        setThePopUp(<EraseCheck title={'האם בטוח למחוק את הגלרייה?'} sucecssFunc={() => removeGallConfirmd(galindx)} />)
    }

    const removeGallConfirmd = (galindx) => {
        let tempo = currentSingle.gallerys.filter((_, indx) => indx !== galindx);

        currentSingle.gallerys = [...tempo];
        setCurentGal()

    }
    const setGallname = (galindx, nameToSet) => {
        let tempo = currentSingle.gallerys;
        tempo[galindx].gallName = nameToSet;
        currentSingle.gallerys = [...tempo];

        setCurentGal();


    }
    const addNewGall = () => {
        let tempo = currentSingle.gallerys;
        tempo.push({
            gallName: "גלריה חדשה",
            mainImg: "",
            gallImages: []
        })

        currentSingle.gallerys = [...tempo];
        setCurentGal();
    }

    const goUP = (indx) => {
        if (indx > 0) {

            // let elm = document.getElementById("imgGall" + indx);
            // let elm2 = document.getElementById("imgGall" + (indx - 1));

            // let tempelm = document.getElementById("imgGall" + indx);
            // document.getElementById("imgGall" + indx).innerHTML = document.getElementById("imgGall" + (indx - 1)).innerHTML;
            // document.getElementById("imgGall" + indx - 1).innerHTML = tempelm.innerHTML;


            let temp = currentSingle.gallerys[indx];
            currentSingle.gallerys[indx] = currentSingle.gallerys[indx - 1];
            currentSingle.gallerys[indx - 1] = temp;


        }
        setCurentGal();

    }
    const goDown = (indx) => {
        if (indx < currentSingle.gallerys.length - 1) {
            let temp = currentSingle.gallerys[indx];
            currentSingle.gallerys[indx] = currentSingle.gallerys[indx + 1];
            currentSingle.gallerys[indx + 1] = temp;
        }
        setCurentGal();
    }

    const setCurentGal = () => {
        let forIndx = -1;
        let counter = 0;
        let bkGal = currentSingle.gallerys.map((itm, indx) => {
            forIndx++;
            counter++;
            return (
                <div key={forIndx} id={`imgBlock${indx}`} className={"fullRow tabsInputs"}>
                    <Card key={indx}>
                        <Accordion.Collapse className="collapseparent" eventKey={counter}>
                            <Card.Body>
                                <div className={"col-md-12 mb-2"}>
                                    <div className={"col-md-5 mb-2 onRight"}>
                                        <label>שם הגלריה</label>
                                        <div className={"input-group"}>
                                            <input type={"text"} className={"form-control"} placeholder={"שם הגלריה"} value={itm.gallName}
                                                onChange={(e) => { setGallname(indx, e.target.value) }} />

                                        </div>
                                    </div>
                                    <div className={"col-md-5 mb-2 onRight"}>
                                        <label className={"fullRow"}>תמונה ראשית</label>
                                        <span className={"explanation mediumst fullROw"}>מוצג באקורדיון</span>
                                        <SelectImgComp indx={indx} firstImgToDisp={itm.mainImg ? itm.mainImg : ""} theFunction={(fUrl) => setTheMainImg(indx, fUrl)} />
                                    </div>

                                    <div className={"col-md-12 mb-2 onRight"}>
                                        <label className={"fullRow"}>תמונות הגלריה</label>
                                        <SelectGalleryComp indx={indx} listImges={itm.gallImages ? itm.gallImages : ""}
                                         theFunction={(fUrl) => setTheImagesLst(indx, fUrl)} />
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                        <Accordion.Toggle as={Card.Header} eventKey={counter}>
                            <span>{itm.gallName}</span><span className={"noBold"}></span>
                        </Accordion.Toggle>
                        <div className={"acordSmallBtns"}>
                            <div className={"onRight divAsIcon pointing optidietDel"}
                                onClick={() => removeGall(indx)}>
                                <i className="far fa-trash-alt ms-text-danger" />
                            </div>
                            <div className={"onRight divAsIcon pointing optidietDel"}
                                onClick={() => goUP(indx)}>
                                <i className="fa fa-arrow-circle-up ms-text-danger" />
                            </div>
                            <div className={"onRight divAsIcon pointing optidietDel"}
                                onClick={() => goDown(indx)}>
                                <i className="fa fa-arrow-circle-down ms-text-danger" />
                            </div>
                        </div>
                    </Card >



                </div>
            )
        })

        setCurntGal(
            <Accordion defaultActiveKey="0" className="has-gap ms-accordion-chevron menuSectionsAcord">
                {bkGal}
            </Accordion>
        );
    }

    return (
        <>
            <div className={"fullRow"}>
                <button type="button" className="onLeft btn btn-primary" onClick={() => addNewGall()}>הוסף גלרייה</button>
            </div>
            <div className="form-row tabsInputs">
                <div className={"col-md-12 mb-2"}>
                    {curntGal}

                </div>

            </div>
            {thePopUp}
        </>


    );
}

export default SectionGallery;